/**
 * Impegno page — scrubbed white/red background accent (bento → sticky → editorial).
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from './camst-counter.js';

gsap.registerPlugin(ScrollTrigger);

var accentInstances = new WeakMap();
var ACCENT_LAYER_Z_INDEX = 1;

function mountAccentLayer(layer) {
  if (layer.parentElement !== document.body) {
    document.body.appendChild(layer);
  }

  layer.style.zIndex = String(ACCENT_LAYER_Z_INDEX);
}

function unmountAccentLayer(root, layer) {
  if (layer && layer.parentElement === document.body) {
    root.insertBefore(layer, root.firstChild);
  }
}

function setImpegnoAccent(progress) {
  var clamped = Math.max(0, Math.min(1, progress));

  document.documentElement.style.setProperty('--camst-impegno-accent', String(clamped));
  document.body.classList.toggle('camst-impegno-accent-active', clamped > 0.01);
}

function resetImpegnoAccent(root, layer) {
  setImpegnoAccent(0);

  if (layer) {
    layer.style.opacity = '0';
  }
}

export function initCamstImpegnoAccent(stickyRoot) {
  if (accentInstances.has(stickyRoot)) {
    return;
  }

  var layer = stickyRoot.querySelector('[data-camst-impegno-accent-layer]');

  if (!layer) {
    return;
  }

  var editorial = document.querySelector('.camst-editorial-stories');

  if (!document.querySelector('.camst-bento-numbers') && !editorial) {
    return;
  }

  mountAccentLayer(layer);

  var reducedMotion = prefersReducedMotion();
  var triggers = [];

  if (reducedMotion) {
    accentInstances.set(stickyRoot, { triggers: [], layer: layer });
    return;
  }

  var ctx = gsap.context(function () {
    triggers.push(
      ScrollTrigger.create({
        trigger: stickyRoot,
        start: 'top 90%',
        end: 'top 20%',
        scrub: 1,
        onUpdate: function (self) {
          setImpegnoAccent(self.progress);
          layer.style.opacity = String(self.progress);
        },
      })
    );

    if (editorial) {
      triggers.push(
        ScrollTrigger.create({
          trigger: editorial,
          start: 'top 90%',
          end: 'top 40%',
          scrub: 1,
          onUpdate: function (self) {
            var value = 1 - self.progress;

            setImpegnoAccent(value);
            layer.style.opacity = String(value);
          },
        })
      );
    }
  }, stickyRoot);

  accentInstances.set(stickyRoot, { triggers: triggers, layer: layer, ctx: ctx });
}

export function teardownCamstImpegnoAccent(stickyRoot) {
  var instance = accentInstances.get(stickyRoot);

  if (!instance) {
    return;
  }

  if (instance.ctx) {
    instance.ctx.revert();
  }

  if (instance.triggers) {
    instance.triggers.forEach(function (trigger) {
      trigger.kill();
    });
  }

  resetImpegnoAccent(stickyRoot, instance.layer);
  unmountAccentLayer(stickyRoot, instance.layer);
  accentInstances.delete(stickyRoot);
}

export function refreshCamstImpegnoAccent() {
  ScrollTrigger.refresh();
}
